import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setNameCredt } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';

function SetNameCred() {
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  const dispatch = useDispatch();
  function setName(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setNameCredt(value));
  }

  return (
    <Wrapper.Default
      width="40%"
      style={{ padding: '0 15px 5px' }}
      isActive
      flexDirection="column"
      alignItens="start">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Nome do Cliente:
      </span>
      <Form.Control
        type="text"
        value={transfersFilterState.credt.name}
        onChange={(event) => setName(event)}
      />
    </Wrapper.Default>
  );
}

export default SetNameCred;
